const routes = [
  {
    path: '/cadastro/recursos-humanos/tipo-equipe',
    name: 'teamType',
    component: () => import('@/views/cadastros/tipoEquipe/TipoEquipe.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Recursos Humanos' }, { title: 'Tipo de Equipe' }],
    },
  },
  {
    path: '/cadastro/recursos-humanos/tipo-equipe/novo',
    name: 'teamTypeNew',
    component: () => import('@/views/cadastros/tipoEquipe/TipoEquipeNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Recursos Humanos' }, { title: 'Tipo de Equipe' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/recursos-humanos/tipo-equipe/:id/editar',
    name: 'teamTypeUpdate',
    component: () => import('@/views/cadastros/tipoEquipe/TipoEquipeNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Recursos Humanos' }, { title: 'Tipo de Equipe' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/recursos-humanos/cargo',
    name: 'employeeRole',
    component: () => import('@/views/cadastros/cargos/Cargos.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Recursos Humanos' }, { title: 'Cargos' }],
    },
  },
  {
    path: '/cadastro/recursos-humanos/cargo/novo',
    name: 'employeeRoleNew',
    component: () => import('@/views/cadastros/cargos/CargosNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Recursos Humanos' }, { title: 'Cargos' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/recursos-humanos/cargo/:id/editar',
    name: 'employeeRoleUpdate',
    component: () => import('@/views/cadastros/cargos/CargosNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Recursos Humanos' }, { title: 'Cargos' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/recursos-humanos/feriados',
    name: 'holiday',
    component: () => import('@/views/cadastros/feriados/Feriados.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Recursos Humanos' }, { title: 'Feriados' }],
    },
  },
  {
    path: '/cadastro/recursos-humanos/feriados/novo',
    name: 'holidayNew',
    component: () => import('@/views/cadastros/feriados/FeriadosNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Recursos Humanos' }, { title: 'Cadastro de Feriados' }],
    },
  },
  {
    path: '/cadastro/recursos-humanos/feriados/:id/editar',
    name: 'holidayUpdate',
    component: () => import('@/views/cadastros/feriados/FeriadosNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Recursos Humanos' }, { title: 'Feriados' }, { title: 'Editar' }],
    },
  },
]

export default routes
